import { H1, P1 } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import styles from './ContentBlock.module.scss'

const ContentBlock = ({ webpart: { paragraph, header } }) => (
  <section className={styles.ContentBlock}>
    <H1
      type="heading"
      weight="bold"
      nestedStyles
      className={`${styles.Title} ${styles.LimitWidth}`}
      dangerouslySetInnerHTML={{ __html: header }}
    />

    <P1
      weight="light"
      type="main"
      nestedStyles
      className={`${styles.Description} ${styles.LimitWidth}`}
      dangerouslySetInnerHTML={{ __html: paragraph }}
    />
  </section>
)

ContentBlock.propTypes = {
  webpart: PropTypes.shape({
    paragraph: PropTypes.string,
    header: PropTypes.string
  })
}

ContentBlock.defaultProps = {
  webpart: {
    paragraph: '',
    header: ''
  }
}

export default ContentBlock
